import { takeEvery, call, put } from "redux-saga/effects";
import { TASK_LIST_REQUESTED } from "../constants/action-types";
import { taskListLoaded, apiError } from "../actions/task";
import config from '../config.json';
import axios from 'axios'
import { buildAuthorizationHeader } from '../middleware/authentication';

const httpsClient = axios.create({
    baseURL: config.API.URL,
    timeout: 10000,
});

export default function* watcherSaga() {
    yield takeEvery(TASK_LIST_REQUESTED, workerSaga);
}

function* workerSaga() {
    try {
        const payload = yield call(getData);
        yield put(taskListLoaded(payload));
    } catch (e) {
        yield put(apiError(e));
    }
}

function getData() {
	return httpsClient.get('/tasks', { 
        'headers' : { 
            'Authorization'               : buildAuthorizationHeader(),
            'Content-Type'                : 'application/json',
        } 
    }).then(response => response.data);
}
